/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Auth } from 'aws-amplify';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth/lib/types';
import FacebookButton from './components/FacebookButton';
import FacebookLogin from './components/FacebookLogin';
import GoogleLogin from './components/GoogleLogin';
import GoogleButton from './components/GoogleButton';
/**
 * Renders the social login component with providers (declared in config)
 *
 * @param  {(response: any) => void} [callback] - callback with response from social provider
 *
 * @example
 * <SocialLogin
 *  callback={response => console.log(response)}
 * />
 */
var SocialLogin = function (_a) {
    var callback = _a.callback, uiConfig = _a.uiConfig;
    var callbackFromSocialProviders = function (provider, response) {
        callback(provider, response);
    };
    var renderLoginProviders = function (config) {
        var render = [];
        config.map(function (el, idx) {
            var className = el.className || null;
            var iconClassName = el.iconClassName || null;
            var textClassName = el.textClassName || null;
            switch (el.provider) {
                case 'facebook':
                    if (el.federatedIdentities) {
                        return render.push(React.createElement(FacebookLogin, { key: idx, appId: el.appId, className: className, uiConfig: uiConfig === null || uiConfig === void 0 ? void 0 : uiConfig.facebook, callback: function (response) {
                                return callbackFromSocialProviders('facebook', response);
                            } }));
                    }
                    return render.push(React.createElement(FacebookButton, { key: idx, className: className, iconClassName: iconClassName, textClassName: textClassName, uiConfig: uiConfig === null || uiConfig === void 0 ? void 0 : uiConfig.facebook, onClick: function () {
                            return Auth.federatedSignIn({
                                provider: CognitoHostedUIIdentityProvider.Facebook,
                            });
                        } }));
                case 'google':
                    if (el.federatedIdentities) {
                        return render.push(React.createElement(GoogleLogin, { key: idx, className: className, appId: el.appId, uiConfig: uiConfig === null || uiConfig === void 0 ? void 0 : uiConfig.google, callback: function (response) {
                                return callbackFromSocialProviders('google', response);
                            } }));
                    }
                    return render.push(React.createElement(GoogleButton, { key: idx, className: className, iconClassName: iconClassName, textClassName: textClassName, uiConfig: uiConfig === null || uiConfig === void 0 ? void 0 : uiConfig.google, onClick: function () {
                            return Auth.federatedSignIn({
                                provider: CognitoHostedUIIdentityProvider.Google,
                            });
                        } }));
                default:
                    return render;
            }
        });
        return render;
    };
    return (React.createElement("div", { className: 'a6y-react-auth__social-login' }, globalThis.A6YReactAuthConfig &&
        globalThis.A6YReactAuthConfig.auth &&
        renderLoginProviders(globalThis.A6YReactAuthConfig.auth)));
};
export default SocialLogin;
//# sourceMappingURL=SocialLogin.js.map